import ApprovalAllowanceApplication from './ApprovalAllowanceApplication';

export default ApprovalAllowanceApplication;
